import { render } from "./AsHeaderEdit.vue?vue&type=template&id=3336b460&ts=true"
import script from "./AsHeaderEdit.vue?vue&type=script&lang=ts"
export * from "./AsHeaderEdit.vue?vue&type=script&lang=ts"

import "./AsHeaderEdit.vue?vue&type=style&index=0&id=3336b460&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__